let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fmpmb")).then(() => parcelRequire('3uKXj'));